import { graphql, useFragment } from 'react-relay';

import {
  PromotionStatusEnum,
  PromotionStatusLabel_promotion$key,
} from '../../../relay/__generated__/PromotionStatusLabel_promotion.graphql';
import EnumPair from '../../core/EnumPair';
import Label, { LabelProps } from '../../core/Label';

const PromotionStatusLabel_promotion = graphql`
  fragment PromotionStatusLabel_promotion on Promotion {
    status
  }
`;

type Props = {
  promotion: PromotionStatusLabel_promotion$key;
} & Omit<LabelProps, 'variant'>;

const PromotionStatusLabel = ({ promotion, ...props }: Props) => {
  const { status } = useFragment(PromotionStatusLabel_promotion, promotion);

  const labelPropsByStatus: Record<PromotionStatusEnum, LabelProps> = {
    'preparing': { variant: 'default' },
    'scheduled': { variant: 'accent' },
    'ongoing': { variant: 'success' },
    'finished': { variant: 'secondary' },
    '%future added value': {},
  };

  return (
    <Label {...labelPropsByStatus[status]} {...props}>
      <EnumPair typename={'PromotionStatusEnum'}>{status}</EnumPair>
    </Label>
  );
};

export default PromotionStatusLabel;
